import { ReactNode } from 'react';

interface InfoItemProps {
  title: string;
  value: string | ReactNode;
}

export const InfoItem = ({ title, value }: InfoItemProps) => {
  return (
    <div className="flex h-full flex-col justify-between gap-2.5 border-l border-gray-200 pl-2.5">
      <div className="text-sm font-bold text-gray">{title}</div>
      <div className="flex ">{value}</div>
    </div>
  );
};
